// extracted by mini-css-extract-plugin
export default {"ArrowButton__button":"ArrowButton__button_Q_QZf","ArrowButton__icon":"ArrowButton__icon_yzvXa"};